import Swal from "sweetalert2";
import router from "../router";
router;

export const showErrorAlert = (doRefresh) => {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Something went wrong!. Please try again. If the problem continues, please contact an admin",
  })
    .then((_) => {
      if (doRefresh) {
        router.push({ name: "content" }).catch((_) => {
          window.location.reload();
        });

        window.location.reload();
      }
    })
    .catch((error) => {
      console.error(error);
      alert(error);
      window.location.reload();
    });
};
